import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';

const AddUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [categories, setCategories] = useState([]);
    
    const [formData, setFormData] = useState({
        expense_date: new Date().toISOString().split('T')[0],
        category: '',
        expense_category_id: '',
        amount: 0,
        note: ''
    });

    useEffect(() => {
        fetchCategories();
        if (id) {
            getSingleData();
        }
    }, [id]);

    const fetchCategories = async () => {
        try {
            const response = await ApiService.request({
                method: 'GET',
                url: 'admin/expense-categories?per_page=100' // Get all categories
            });
            if (response.data.status) {
                setCategories(response.data.data.categories);
            }
        } catch (error) {
            console.error('Failed to fetch categories', error);
        }
    };

    const getSingleData = async () => {
        setIsLoader(true);
        try {
            const response = await ApiService.request({
                method: 'GET',
                url: `admin/expenses/${id}`,
            });
            const data = response.data;
            if (data.status) {
                const expense = data.data.expense;
                setFormData({
                    expense_date: expense.expense_date,
                    category: expense.category,
                    expense_category_id: expense.expense_category_id || '',
                    amount: expense.amount,
                    note: expense.note || ''
                });
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error('Failed to load expense data');
        } finally {
            setIsLoader(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoader(true);
        try {
            const response = await ApiService.request({
                method: id ? 'PUT' : 'POST',
                url: id ? `admin/expenses/${id}` : 'admin/expenses',
                data: formData
            });

            if (response.data.status) {
                toast.success(response.data.message);
                navigate('/expenses');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Something went wrong');
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            {id ? 'Edit Expense' : 'Create Expense'}
                        </h1>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to="/expenses" className="btn btn-sm fw-bold btn-secondary">Back</Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label required">Date</label>
                                    <input 
                                        type="date" 
                                        className="form-control form-control-solid"
                                        value={formData.expense_date}
                                        onChange={(e) => setFormData({...formData, expense_date: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Category</label>
                                    <select
                                        className="form-control form-control-solid"
                                        value={formData.expense_category_id}
                                        onChange={(e) => setFormData({...formData, expense_category_id: e.target.value})}
                                    >
                                        <option value="">Select Category</option>
                                        {categories.map((cat) => (
                                            <option key={cat.id} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label required">Amount</label>
                                    <input 
                                        type="number" 
                                        className="form-control form-control-solid"
                                        value={formData.amount}
                                        onChange={(e) => setFormData({...formData, amount: e.target.value})}
                                        required
                                        min="0"
                                        step="0.01"
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Note</label>
                                    <textarea 
                                        className="form-control form-control-solid"
                                        value={formData.note}
                                        onChange={(e) => setFormData({...formData, note: e.target.value})}
                                    ></textarea>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                                        {isLoader ? 'Saving...' : 'Save Expense'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUpdate;
